var SCM = SCM || {};
SCM.StickyElements = SCM.StickyElements || {};

SCM.StickyElements = (function($){
    var currPage = '';
    var lastScrollPosY = window.scrollY || window.pageYOffset;
	var ticking = false;
	var rAF = null;
	var currJumpLinkIndex = 0;
    var $body;
    var $articleBrowseMobileNav;
    var $issueBrowseMobileNav;
    var $pageColumnLeft;
    var $toolbarWrap;
    var $stickyElements;
    var $currentHeaderHeight;
        
    /**
    * Returns module API
    * @returns {object}
    */
    return {
        init: init
    };

    function init(){
        $body = $('body'),
        $pageColumnLeft = $('.page-column--left'),
        $toolbarWrap = $('.toolbar-wrap');
        $stickyElements = $('.page-column--left, .toolbar-wrap, .sr-filters, .article-browse-mobile-nav');
        $currentHeaderHeight = $('section.master-header').height();

        // Article page
        if ($body.hasClass('pg_article')) {
            currPage = 'article';
            $articleBrowseMobileNav = $('.article-browse-mobile-nav');
        }

        // Issue Results
        if ($body.hasClass('pg_issue')) {
            currPage = 'issue';
            $issueBrowseMobileNav = $('.issue-browse-mobile-nav');
        }

        // Search Results
        if ($body.hasClass('pg_solr/searchresults')) {
            currPage = 'search';
            $srFilters = $('.sr-filters');
        }

        window.addEventListener('scroll', onScroll, false);
        updateStickyElements();
    }

    /**
    * Handle window scroll, and capture current scroll position Y
    */
    function onScroll() {
        lastScrollPosY = window.scrollY || window.pageYOffset;
        requestTick();
    }

    /**
    * Request new rAF if not active
    */
    function requestTick() {
        if (!ticking) {
            rAF = requestAnimationFrame(updateStickyElements);
            ticking = true;
        }
    }

    

    function updateStickyElements(){
        ticking = false;
    
        // Article page article toolbar
        if(SCM.SiteJS.getViewportWidth() > 1023){
            if (currPage === 'article') {
                if (lastScrollPosY >= $currentHeaderHeight - 25) {
                    $toolbarWrap.addClass('fixed');
                }
            }
        }

        if (lastScrollPosY >= $currentHeaderHeight - 25) {
            
            // Article page
            if (currPage === 'article') {
                $pageColumnLeft.addClass('fixed');
                $articleBrowseMobileNav.addClass('fixed');
            }

            // Search Results (only for tablet/mobile)
            if (currPage === 'search' && SCM.SiteJS.getViewportWidth() <= 1023) {
                $srFilters.addClass('fixed');
            }

        } else {
            // remove fixed from all 'sticky' elements
            if (currPage === 'article' || currPage === 'search') {
                $stickyElements.removeClass('fixed');
             }
        }// >= 345

        if (lastScrollPosY >= $currentHeaderHeight + 175 && currPage === 'issue') {
            // Issue Results
            $pageColumnLeft.addClass('fixed');
        } else if(currPage === 'issue'){
            $pageColumnLeft.removeClass('fixed');
        }

        if (lastScrollPosY >= $currentHeaderHeight + 190 && currPage === 'issue') {
            $issueBrowseMobileNav.addClass('fixed');
        } else if(currPage === 'issue') {
            $issueBrowseMobileNav.removeClass('fixed');
        }// >= 620
}

})(jQuery);